export default __webpack_public_path__ + "static/media/pin-pickup.3f0b5b40.svg";